import { Injectable } from '@angular/core';
import { EditorSelection } from 'guideline/domain';
import { BehaviorSubject, Observable } from 'rxjs';

import {
  FlowchartActionDto,
  FlowchartContainerDto,
  FlowchartDecisionNodeDto,
  FlowchartLinkDto,
  FlowchartSelectionBehaviorDto,
  FlowchartStartNodeDto,
  FlowchartSubflowDto,
  FlowchartTextBlockDto,
  NewGuidelineChapter,
} from '@treetop/shared/model';

export type FlowchartNode = Partial<
  FlowchartStartNodeDto &
    FlowchartTextBlockDto &
    FlowchartActionDto &
    FlowchartDecisionNodeDto &
    FlowchartSelectionBehaviorDto &
    FlowchartLinkDto &
    FlowchartContainerDto &
    FlowchartSubflowDto &
    NewGuidelineChapter
>;

@Injectable({
  providedIn: 'root',
})
export class FlowchartSidebarStoreService {
  private currentDto = new BehaviorSubject<FlowchartNode>(null);

  public setDto(selection: EditorSelection): void {
    if (selection?.element) {
      this.currentDto.next(selection.element as FlowchartNode);
    } else this.currentDto.next(null);
  }

  public getCurrentDto(): Observable<FlowchartNode> {
    return this.currentDto;
  }
}
